import moment from 'moment-timezone';
import {AiTokenLimitPeriod} from 'src/openapi/admin/models/AiTokenLimitPeriod';

import type {AiTokenLimit} from 'src/openapi/admin/models/AiTokenLimit';
import type {AiTokenTemporaryLimit} from 'src/openapi/admin/models/AiTokenTemporaryLimit';

export const AI_TOKEN_PERIODS = [AiTokenLimitPeriod.DAILY, AiTokenLimitPeriod.WEEKLY] as const;
export const AI_TOKEN_LABELS: Record<`${AiTokenLimitPeriod}`, string> = {
    DAILY: 'Daily limit',
    WEEKLY: 'Weekly limit',
};

export const isAiTokenAmountValid = (amount: number | undefined): amount is number => (
    amount !== undefined && Number.isSafeInteger(amount) && amount >= 0
);

export const areAiTokenLimitsEqual = (
    current: Array<AiTokenLimit | AiTokenTemporaryLimit>,
    initial: Array<AiTokenLimit | AiTokenTemporaryLimit>,
) => current.length === initial.length && current.every(limit => {
    const previous = initial.find(item => item.period === limit.period);
    if (!previous || previous.amount !== limit.amount) {
        return false;
    }
    const expiry = 'expiresOn' in limit ? limit.expiresOn : undefined;
    const previousExpiry = 'expiresOn' in previous ? previous.expiresOn : undefined;
    return expiry === previousExpiry || (!!expiry && !!previousExpiry && moment(expiry).isSame(previousExpiry));
});

export const toAiTokenExpiry = (until: string, timeZone: string) => (
    moment.tz(until, 'YYYY-MM-DD', true, timeZone).add(1, 'day').startOf('day').toISOString()
);

export const toAiTokenUntil = (expiresOn: string, timeZone: string) => (
    moment(expiresOn).tz(timeZone).subtract(1, 'millisecond').format('YYYY-MM-DD')
);
